export default __webpack_public_path__ + "locales/ro/PeopleTranslations.json?hash=9888c39b75c59f18b96cb4eea5e151c0";